import React, { useState } from 'react'
import { ErrorBoundary } from './ErrorBoundary'

/**
 * Diagnostics-only harness used to verify ErrorBoundary behavior end-to-end in
 * the production preview build (where dev-only throws do not fire). It is reached
 * only via the explicit, namespaced route `/__diag/error-boundary` and renders no
 * application data, so it is inert for real users. Not part of any product flow.
 */

const Bomb: React.FC<{ explode: boolean }> = ({ explode }) => {
  if (explode) throw new Error('Probe boom')
  return <div data-testid="probe-child">probe child ok</div>
}

export const ErrorBoundaryProbe: React.FC = () => {
  // Boundary A: manual retry, no resetKeys.
  const [explodeA, setExplodeA] = useState(false)
  // Boundary B: auto-recovers when resetKeys change.
  const [explodeB, setExplodeB] = useState(false)

  return (
    <div style={{ padding: '2rem', display: 'grid', gap: '2rem', maxWidth: 640, margin: '0 auto' }}>
      <section data-testid="probe-section-a">
        <h2>Manual retry</h2>
        <button type="button" data-testid="probe-a-explode" onClick={() => setExplodeA(true)}>boom A</button>
        <button type="button" data-testid="probe-a-fix" onClick={() => setExplodeA(false)}>fix A</button>
        <ErrorBoundary testId="probe-a-boundary" message="Probe A failed">
          <Bomb explode={explodeA} />
        </ErrorBoundary>
      </section>

      <section data-testid="probe-section-b">
        <h2>resetKeys auto-recovery</h2>
        <button type="button" data-testid="probe-b-explode" onClick={() => setExplodeB(true)}>boom B</button>
        <button type="button" data-testid="probe-b-fix" onClick={() => setExplodeB(false)}>fix B</button>
        <ErrorBoundary testId="probe-b-boundary" message="Probe B failed" resetKeys={[explodeB]}>
          <Bomb explode={explodeB} />
        </ErrorBoundary>
      </section>
    </div>
  )
}
